import { createSelector } from 'reselect'; // @ts-expect-error untyped dependency

import { makePermissionComponent } from 'ecosystem-marketplace-core/components/permissions';
import * as AppContext from '../constants/AppContext';
export function getAppContext(state) {
  return state.app.appContext;
}
const coreTypeMap = {
  [AppContext.ADMIN_PREVIEW]: 'admin-preview',
  [AppContext.IN_APP]: 'app',
  [AppContext.PUBLIC]: 'public'
};
export function getAppContextCoreType(state) {
  return coreTypeMap[state.app.appContext];
}

function makeAppContextSelector(appContext) {
  return createSelector([getAppContext], _appContext => {
    return _appContext === appContext;
  });
}

export const getIsInApp = makeAppContextSelector(AppContext.IN_APP);
export const getIsPublicApp = makeAppContextSelector(AppContext.PUBLIC);
export const getIsAdminPreview = makeAppContextSelector(AppContext.ADMIN_PREVIEW);
export const PublicAppContext = makePermissionComponent(getIsPublicApp);